// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3fr4t","layout":"App_layout__1vqXm","footer":"App_footer__3uZmK"};